export default "__VITE_PUBLIC_ASSET__576776d4__"